import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=22b0ec0b&scoped=true"
import script from "./CouponForm.vue?vue&type=script&lang=js"
export * from "./CouponForm.vue?vue&type=script&lang=js"
import style0 from "./CouponForm.vue?vue&type=style&index=0&id=22b0ec0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0ec0b",
  null
  
)

export default component.exports